
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Region"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"region_code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"api"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"region"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"region"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"region_code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"region_code"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"region_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"region_code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"electricity_grid_carbon"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"electricity_fixed_daily_price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"electricity_unit_band1_price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"electricity_unit_band2_price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"electricity_unit_band3_price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"modified_by"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"roadworthiness"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"electricity_unit_controlled_price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"electricity_unit_export_price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"electricity_chargepoint_unit_price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fuel_petrol_price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fuel_diesel_price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fuel_hydrogen_price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"electricity_solar_unit_subsidy_price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"energy_home_total_annual"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"energy_home_selector"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"solar_cost_model_type"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":629}};
    doc.loc.source = {"body":"query Region($region_code: String!) @api(name: region) {\n  region(region_code: $region_code) {\n    region_name\n    region_code\n    electricity_grid_carbon\n    electricity_fixed_daily_price\n    electricity_unit_band1_price\n    electricity_unit_band2_price\n    electricity_unit_band3_price\n    modified_by\n    roadworthiness\n    electricity_unit_controlled_price\n    electricity_unit_export_price\n    electricity_chargepoint_unit_price\n    fuel_petrol_price\n    fuel_diesel_price\n    fuel_hydrogen_price\n    electricity_solar_unit_subsidy_price\n    energy_home_total_annual\n    energy_home_selector\n    solar_cost_model_type\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["Region"] = oneQuery(doc, "Region");
        
